import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class MigrateWebsiteGroupForm {
  public originServerSource: string = '';

  public originServerTarget: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    originServer: [
      (v: string) => !!v || 'Server is required',
      (v: string) => v.length > 1 || 'Server should be at least 2 characters long',
    ],
  };
}
